/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */
import Icon from '@ant-design/icons';

const DanishFlagIconSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1.1em" height="1.1em" id="flag-icons-dk" viewBox="0 0 640 480">
    <path fill="#c8102e" d="M0 0h640v480H0z"/>
    <path fill="#fff" d="M205.7 0h68.6v480h-68.6z"/>
    <path fill="#fff" d="M0 205.7h640v68.6H0z"/>
  </svg>
);

export const DanishFlagIcon = (props) => (
  <Icon component={DanishFlagIconSvg} {...props} />
);
